import { useContext } from 'react'

// context
import { AppContext } from '../../../App'

// styles
import styles from './stepper-item.module.scss'

export type StepperItemProps = {
	readonly index?: number
	readonly label?: string
} & React.LiHTMLAttributes<HTMLLIElement>

const StepperItem = (props: StepperItemProps): JSX.Element => {
	const appContext = useContext(AppContext)
	const { className, index, label, ...attr } = props

	const currentStep = index === appContext?.currentStep
	const disabled = (index || 0) > (appContext?.currentStep || 0)

	const clickHandler = () => {
		appContext?.setCurrentStep(index || 1)
	}

	return (
		<li
			{...attr}
			className={[styles.stepperItem, className].join(' ').trim()}
		>
			<button
				type="button"
				className={styles.button}
				aria-current={currentStep ? 'page' : undefined}
				disabled={disabled ? true : undefined}
				onClick={clickHandler}
			>
				{index && <span className={styles.pellet}>{index}</span>}
				{label && <span className={styles.label}>{label}</span>}
			</button>
		</li>
	)
}

export default StepperItem
